module.exports = __webpack_public_path__ + "static/pc.h264-8775f0e4c0abc7c39d7fd96533ef007a.mp4";